export const formatPhoneNumber = (value: string) => {
  let phoneNumber = value.replace(/\D/g, "");
  if (phoneNumber.length < 4) {
    return phoneNumber;
  }
  if (phoneNumber.startsWith("1")) {
    phoneNumber = phoneNumber.slice(1);
  }
  const areaCode = `(${phoneNumber.slice(0, 3)})`;
  if (phoneNumber.length < 7) {
    return `${areaCode} ${phoneNumber.slice(3)}`;
  }
  const firstThree = phoneNumber.slice(3, 6);
  return `${areaCode} ${firstThree}-${phoneNumber.slice(6, 10)}`;
};

export const formatPhoneNumberDashed = (value: string): string => {
  const digits = value.replace(/\D/g, "").slice(-10);
  if (digits.length !== 10) {
    return value;
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const validatePhoneNumber = (value: string) =>
  value.replace(/\D/g, "").length === 10 ||
  "Please enter a valid 10-digit phone number.";

/** Matches common US display formats like 833-555-0100 and (833) 555-0100. */
export const US_DISPLAY_PHONE_PATTERN =
  /(?:\(\d{3}\) \d{3}-\d{4}|\d{3}-\d{3}-\d{4})/;

export type TextPhoneSegment =
  | { type: "text"; value: string }
  | { type: "phone"; value: string; telHref: string };

export function toTelHref(phone: string): string {
  return `tel:${phone.replace(/\D/g, "")}`;
}

export function segmentTextByPhoneNumbers(text: string): TextPhoneSegment[] {
  const segments: TextPhoneSegment[] = [];
  let lastIndex = 0;
  const pattern = new RegExp(US_DISPLAY_PHONE_PATTERN.source, "g");

  for (const match of text.matchAll(pattern)) {
    const phone = match[0];
    const start = match.index ?? 0;

    if (start > lastIndex) {
      segments.push({ type: "text", value: text.slice(lastIndex, start) });
    }

    segments.push({
      type: "phone",
      value: phone,
      telHref: toTelHref(phone),
    });

    lastIndex = start + phone.length;
  }

  if (lastIndex < text.length) {
    segments.push({ type: "text", value: text.slice(lastIndex) });
  }

  return segments;
}
